import React, { useEffect, useState } from 'react';
import AdminLayout from '../UI/Layout/AdminLayout';
import Spining from '../UI/Spining/Spining';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import Axios from '../../axios/Axios';
import axios from "axios"
import { NODE_HOST_URL_v1 } from '../Dashboard/api/Api';
import { userloginDetails } from '../Utils/AdminAuth';
import Alert from '../UI/Alert/Alert';
const AdminKarixReport = () => {


    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const adminType = lStorage.user.isAdmin;
    const username = lStorage.user.username;

    const [isLoading, setIsLoading] = useState(false);
    const [selectedParent, setSelectedParent] = useState({ label: "Datagen", value: "datagen" });
    const [error, setError] = useState({
        isError: false,
        errorMessage: "",
        messageType: ""
    })

    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());

    const [tableData, setTableData] = useState([]);

    const [csvFile, setCsvFile] = useState(null);

    const customStyles = {
        control: (provided) => ({
            ...provided,
            cursor: "pointer",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        option: (style) => ({
            ...style,
            fontSize: "13px",
        }),
    };

    // CSV Upload Handler
    const handleCSVUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setCsvFile(file);
        UploadCsvToServer(file);   // auto upload
    };

    const handleSearch = async () => {
        setIsLoading(true);
        clearError()
        try {

            const payload = {
                method: "FetchSummary",
                parentName: selectedParent?.value,
                fromdate: formatDate(fromDate),
                todate: formatDate(toDate),
                user_type: adminType
            }

            const { data } = await axios.post(`${NODE_HOST_URL_v1}/admin/KarixReport`, payload);
            if (data.success) {
                setTableData(data.data)

            } else {
                setTableData([])
                setError({
                    errorMessage: `${data?.message}` || "Something went wrong, please try again later",
                    isError: true,
                    messageType: " alert alert-danger"
                })

            }


        } catch (error) {
            if (error.response && error.response.status === 429) {
                setError({
                    errorMessage: "Too many requests. Please try again later.",
                    isError: true,
                    messageType: "alert alert-danger"
                })

            } else {
                console.error(error);
                // toast.error(`${error.response?.data?.message}` || "Something went wrong, please try again later")
                setError({
                    errorMessage: `${error.response?.data?.message}` || "Something went wrong, please try again later",
                    isError: true,
                    messageType: "alert alert alert-danger"
                })
            }


        }
        finally {
            setIsLoading(false);
        }
    }



    const UploadCsvToServer = async (file) => {
        try {
            setIsLoading(true);

            const formData = new FormData();
            formData.append("file", file);
            formData.append("method", "uploadData");
            formData.append("user_type", adminType);
            formData.append("user_id", userId);
            formData.append("token", userToken);

            const { data } = await axios.post(
                `${NODE_HOST_URL_v1}/admin/KarixReport`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            if (data.success) {
                alert("CSV uploaded successfully");
            } else {
                alert(data.message || "Upload failed");
            }
        } catch (error) {
            alert(error.response?.data?.message || "Upload failed");
            console.error("CSV Upload Error:", error);
        } finally {
            setIsLoading(false);
            setCsvFile(null);
        }
    };

    const handleParentChange = (option) => {
        setSelectedParent(option);
    };

    const formatDate = (date) => {
        if (!date) return "";
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const d = String(date.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    };


    const clearError = () => {
        setError({
            isError: false,
            errorMessage: "",
            messageType: ""
        })
    }

    return (
        <div>
            <AdminLayout>

                <div className="row">
                    {error.isError &&
                        <Alert type={error.messageType} clearError={clearError}>
                            {error.errorMessage}
                        </Alert>
                    }

                    <div className="card">
                        {isLoading && <Spining />}

                        <div className="card-body">

                            {/* HEADER + CSV UPLOAD */}
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h6 className="card-subtitle text-muted mb-0">
                                    <b>KARIX Report</b>
                                </h6>

                                <div>
                                    {/* Hidden File Input */}
                                    <input
                                        type="file"
                                        accept=".csv"
                                        id="csvUploadInput"
                                        style={{ display: "none" }}
                                        onChange={handleCSVUpload}
                                    />

                                    <button
                                        className="btn btn-success"
                                        onClick={() => document.getElementById("csvUploadInput").click()}
                                        disabled={isLoading}
                                        style={{ minWidth: "120px" }}
                                    >
                                        {isLoading ? "Uploading..." : "Upload CSV"}
                                    </button>

                                    {csvFile && (
                                        <div style={{ fontSize: "12px" }} className="mt-1 text-success">
                                            Selected: {csvFile.name}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* FILTERS */}
                            <div className="mb-3 p-3 rounded"
                                style={{ background: "#F9FAFF", border: "1px solid #E4E6F1" }}>
                                <div className="row align-items-end">

                                    <div className="col-lg-3 col-md-6 mb-3">
                                        <label className="font-weight-bold mb-1">Select Parent</label>
                                        <div style={{ minHeight: "45px" }}>
                                            <Select
                                                onChange={handleParentChange}
                                                options={[
                                                    { label: "Datagen", value: "datagen" },
                                                    { label: "Serri", value: "serri" },
                                                ]}
                                                placeholder="Select Parent"
                                                styles={{
                                                    ...customStyles,
                                                    control: (base) => ({
                                                        ...base,
                                                        minHeight: "45px",
                                                        height: "45px",
                                                        cursor: "pointer"
                                                    })
                                                }}
                                                value={selectedParent}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-6 mb-3 d-flex flex-column">
                                        <label className="font-weight-bold mb-1">From Date</label>
                                        <DatePicker
                                            className="form-control"
                                            selected={fromDate}
                                            onChange={setFromDate}
                                            style={{ height: "45px" }}
                                        />
                                    </div>

                                    <div className="col-lg-3 col-md-6 mb-3 d-flex flex-column">
                                        <label className="font-weight-bold mb-1">To Date</label>
                                        <DatePicker
                                            className="form-control"
                                            selected={toDate}
                                            onChange={setToDate}
                                            style={{ height: "45px" }}
                                        />
                                    </div>

                                    <div className="col-lg-3 col-md-6 mb-3 d-flex align-items-end">
                                        <button
                                            type="button"
                                            className="btn btn-success btn-block"
                                            style={{ height: "45px" }}
                                            onClick={handleSearch}
                                            disabled={isLoading}
                                        >
                                            Search
                                        </button>
                                    </div>

                                </div>
                            </div>

                            {/* TABLE OUTPUT */}
                            <div className="card mt-4">
                                {tableData.length > 0 ? (
                                    <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                                        <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                            <thead>
                                                <tr>
                                                    {[
                                                        "Date",
                                                        "Parent",
                                                        "Username",
                                                        "ACode",
                                                        "Total",
                                                        "Sent",
                                                        "Attempted",
                                                        "Delivered",
                                                        "Failed",
                                                        "Dropped",
                                                        "Read Count",
                                                    ].map((title, index) => (
                                                        <th
                                                            key={index}
                                                            style={{
                                                                backgroundColor: "#3F3966",
                                                                color: "white",
                                                                padding: "10px",
                                                                fontSize: "13px"
                                                            }}
                                                        >
                                                            {title}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {tableData.map((row, index) => (
                                                    <tr key={index}>
                                                        <td style={{ padding: ".6rem" }}>{row.date}</td>
                                                        <td style={{ padding: ".6rem" }}>{row.parent}</td>
                                                        <td style={{ padding: ".6rem" }}>{row.username}</td>
                                                        <td style={{ padding: ".6rem" }}>{row.acode}</td>
                                                        <td style={{ padding: ".6rem" }}>{row.total}</td>
                                                        <td style={{ padding: ".6rem" }}>{row.sent}</td>
                                                        <td style={{ padding: ".6rem" }}>{row.attempted}</td>
                                                        <td style={{ padding: ".6rem" }}>{row.delivered}</td>
                                                        <td style={{ padding: ".6rem" }}>{row.failed}</td>
                                                        <td style={{ padding: ".6rem" }}>{row.dropped}</td>
                                                        <td style={{ padding: ".6rem" }}>{row.read_count}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <p className="m-3 text-muted">No records found</p>
                                )}
                            </div>


                        </div>
                    </div>

                </div>

            </AdminLayout>
        </div>
    );

};

export default AdminKarixReport;
